import React from "react"
import WingsCardContainer from "./WingsCardContainer"
import WingsCardDetail from "./WingsCardDetail"
import { useIntl } from "react-intl"

const WingsCompanyCard = ({
  img,
  title,
  slug,
  location,
  sizes,
  industries,
  objectID,
  contentType = "companies",
  employeeCount,
}) => {
  const { formatMessage } = useIntl()

  return (
    <WingsCardContainer
      imageUrl={img}
      imageAlt={title ? `image of ${title}` : 'Company image'}
      title={title}
      to={`/company/${slug}`}
      subtitle={location}
      objectID={objectID}
      slug={slug}
      contentType={contentType}
    >
      {(industries?.length || sizes?.length) && (
        <div className="w-flex w-flex-column w-justify-start w-items-start w-gap-xs">
          {industries?.length && (
            <WingsCardDetail
              label={formatMessage({id: "company-card-industries", defaultMessage:"Industries"})}
              value={industries.join(", ")}
            />
          )}
          {!!employeeCount && (
            <WingsCardDetail
              label={formatMessage({id: "company-card-employees", defaultMessage:"Employees"})}
              value={employeeCount}
            />
          )}
          {(!employeeCount && !!sizes?.length) && (
            <WingsCardDetail
              label={formatMessage({id: "company-card-size", defaultMessage:"Size"})}
              value={sizes.join(", ")}
            />
          )}
        </div>
      )}
    </WingsCardContainer>
  )
}

export default WingsCompanyCard
